import { Routes, Route } from 'react-router-dom'

import Layout from './components/Layout'
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import OurWork from './pages/OurWork'
import Contact from './pages/Contact'
import JoinOurTeam from './pages/JoinOurTeam'
import TermsOfService from './pages/TermsOfService'
import Sitemap from './pages/Sitemap'

function App() {
  console.log('App component rendering')
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/work" element={<OurWork />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/join-our-team" element={<JoinOurTeam />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/sitemap" element={<Sitemap />} />
      </Routes>
    </Layout>
  )
}

export default App 